module.exports = __webpack_public_path__ + "static/media/i_female_doctor.b6a7fcb2.svg";